import React, { Component } from 'react';
import * as ajax from './../../ajax.js';
import * as lang from './../../lang.js';

import PopUpWindow from './../../components/PopUpWindow';
import { Container, Row, Col, Button } from 'react-bootstrap';

import TextInsertField from './../../components/TextInsertField';
import TextFormatter from './../../components/TextFormatter';

class SzovegSablonokView extends Component {

    constructor(props) {
        super(props);
        this.state = {
            szovegSablonok_id: ''
            , szovegSablonok_kategoria_konstans: ''
            , szovegSablonok_nev: ''
            , szovegSablonok_szoveg: ''

        }


        this.references = [];
        this.references['szovegSablonok_id'] = React.createRef();
        this.references['szovegSablonok_kategoria_konstans'] = React.createRef();
        this.references['szovegSablonok_nev'] = React.createRef();
        this.references['szovegSablonok_szoveg'] = React.createRef();


        this.validators = [];
        this.validators['szovegSablonok_id'] = {fieldName: 'szovegSablonok_id', dataType: 'INT', value: this.state.szovegSablonok_id, mandatory: false, min: null, max: null};
        this.validators['szovegSablonok_kategoria_konstans'] = {fieldName: 'szovegSablonok_kategoria_konstans', dataType: 'CHAR', value: this.state.szovegSablonok_kategoria_konstans, mandatory: false, min: null, max: null};
        this.validators['szovegSablonok_nev'] = {fieldName: 'szovegSablonok_nev', dataType: 'VARCHAR', value: this.state.szovegSablonok_nev, mandatory: false, min: null, max: null};
        this.validators['szovegSablonok_szoveg'] = {fieldName: 'szovegSablonok_szoveg', dataType: 'VARCHAR', value: this.state.szovegSablonok_szoveg, mandatory: false, min: null, max: null};


        this.error = false;
        this.msg = "";

        this.load();

    }

    componentDidUpdate(prevProps) {
        if (prevProps.id !== this.props.id) {
            this.load();
        }
    }

    reset = function () {
        this.setState({szovegSablonok_id: ''
            , szovegSablonok_kategoria_konstans: ''
            , szovegSablonok_nev: ''
            , szovegSablonok_szoveg: ''
        });
    }

    setBack = function (id, value) {
        this.setState({[id]: value});
    }

    getForm = function () {
        return  <Container>
            <Row>
                <Col style={{textAlign: 'left'}}>{lang.getTitleBold('szovegSablonok_kategoria_konstans')}</Col>
                <Col style={{textAlign: 'right'}}>
                <select
                    disabled
                    style={{minWidth: 255}}
                    id={'szovegSablonok_kategoria_konstans'} 
                    value={this.state.szovegSablonok_kategoria_konstans}  
                    onChange={(e) => this.setBack(e.target.id, e.target.value)}
                    reference={this.references['szovegSablonok_kategoria_konstans']}
                    editable={false}
                    theme={this.props.theme}
                    >
                    <option value={'HATARIDO'}>{lang.getTitleBold('HATARIDO')}</option>
                    <option value={'GARANCIA'}>{lang.getTitleBold('GARANCIA')}</option>
                    <option value={'LEIRAS'}>{lang.getTitleBold('LEIRAS')}</option>
                    <option value={'MUSZAKI_LEIRAS'}>{lang.getTitleBold('MUSZAKI_LEIRAS')}</option>
                    <option value={'MEGJEGYZES'}>{lang.getTitleBold('MEGJEGYZES')}</option>
                    <option value={'FIZETESI_FELTETELEK'}>{lang.getTitleBold('FIZETESI_FELTETELEK')}</option>
                    <option value={'NEM_TARTALMAZZA'}>{lang.getTitleBold('NEM_TARTALMAZZA')}</option>
                </select>
                </Col>
          
                <Col style={{textAlign: 'left'}}>{lang.getTitleBold('szovegSablonok_nev')}</Col>
                <Col style={{textAlign: 'right'}}>
                <TextInsertField 
                    id={'szovegSablonok_nev'} 
                    value={this.state.szovegSablonok_nev}  
                    setBack={this.setBack.bind(this)}
                    reference={this.references['szovegSablonok_nev']}
                    editable={false}
                    theme={this.props.theme}
                    />
                </Col>
                <Col></Col>
                <Col></Col>
            </Row>
            <Row>
                <Col md={12} style={{textAlign: 'left'}}>{lang.getTitleBold('szovegSablonok_szoveg')}</Col>
                <Col md={12} style={{textAlign: 'right'}}>
                <TextFormatter
                    id={'szovegSablonok_szoveg'} 
                    value={this.state.szovegSablonok_szoveg}  
                    setBack={this.setBack.bind(this)}
                    reference={this.references['szovegSablonok_szoveg']}
                    editable={false}
                    theme={this.props.theme}
                    />
                </Col>
                
            </Row>
        
        </Container>
    }

    closeForm = function () {
        this.reset();
        this.props.closeForm();

    }

    transactionSuccess = function () {
        this.error = false;
        this.msg = lang.getTitleBold('transaction_success');
        this.setState({});
    }

    transactionFail = function (errorStringConstant) {
        this.error = true;
        this.msg = lang.getTitleBold(errorStringConstant);
        this.setState({});
    }

    concatAdditionalParams = function () {
        // var stateClone = JSON.parse(JSON.stringify(this.state));
        if (typeof this.props.additionalParams == 'undefined') {
            return this.state;
        }

        if (this.props.additionalParams == null) {
            return this.state;
        }

        var additionalParams = this.props.additionalParams;
        for (var i = 0; i < additionalParams.length; i++) {
            var additionalParam = additionalParams[i];
            for (const property in additionalParam) {
                this.state[property] = additionalParam[property];
            }
        }
        return this.state;
    }


    load = function () {
        var validator = ajax.Validator();
        var validForm = validator.formValidator(this.references, this.validators, this.state);
        if (validForm == false) {
            return false;
        }
        var self = this;
        try {
            const url = ajax.getUrlBase() + "modules/SzovegSablonok/szovegSablonokFormLoader.php";

            return fetch(url, {
                method: "POST",
                headers: new Headers({"Content-Type": "application/json"}),
                body: JSON.stringify({id: this.props.id})
            }).then(response => {
                if (response.ok) {
                    return response.json().then(response => {
                        if (response.success) {
                            this.setState(response.data[0]);
                        } else {
                            self.transactionFail(response.fail);
                        }

                    }).catch(function (jsonError) {
                        
                        if (null == jsonError) {
                            self.transactionFail('Fetch JSON error');
                            console.error("Fetch JSON error:");
                        } else {
                            self.transactionFail("Fetch JSON error:" + String(jsonError));
                            console.error("Fetch JSON error:" + String(jsonError));
                        }
                    });
                } else {
                    
                    self.transactionFail("HTTP status error:", response.statusText);
                    console.error("HTTP status error:", response.statusText);
                }
            }).catch(function (error) {
                
                self.transactionFail("Fetch error:", error);
                console.error("Fetch error:", error);
                if (null == error) {
                    self.transactionFail("Fetch error:");
                    console.error("Fetch error:");
                } else {
                    self.transactionFail("Fetch error:" + String(error));
                    console.error("Fetch error:" + String(error));
                }
            });
        } catch (ex) {
            
            self.transactionFail("Fetch exception:", String(ex));
            console.error("Fetch exception:", String(ex));
        }
    }

    render() {
        var form = this.getForm();
        var className = (this.props.theme == "true") ? "Dark" : "Light";
        return (<PopUpWindow theme={this.props.theme}  style={{minWidth: 1200}}>
            <div className={'popupWrapper' + className} id="SzovegSablonokUpdate">
                <div  className={"popupHeader" + className} >
                    <Row>
                        <Col></Col>
                        <Col style={{textAlign: 'center'}}>{lang.getTitleBold('SzovegSablonokView')}</Col>
                        <Col style={{textAlign: 'right'}}>
                        <Button className={'btn-sm'} variant="danger" onClick={this.closeForm.bind(this)}>{lang.getTitle('close')}</Button>
                        </Col>
                    </Row>
                </div>
                <div  className={"popupBody" + className} >{form}</div>
                <div  className={"popupFooter" + className} >
                    <Row>
                        <Col>
                        <div style={{whiteSpace: 'break-spaces'}}>
                            {this.msg} 
                        </div>
        
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                        <Button className={'btn-sm'} id={'save'} onClick={this.closeForm.bind(this)} variant="success" style={{marginTop: '5px'}}>{lang.getTitle('close')}</Button>&nbsp;&nbsp;&nbsp;      
                        </Col>
                    </Row>
                    <Row>
                        <Col style={{minHeight: '10px'}}>
 
                        </Col>
                    </Row>
        
                </div>
            </div>
        </PopUpWindow>);
    }
}

export default SzovegSablonokView;

